import { MovableDialog } from '@/components/shared/MovableDialog';
// Phase compiler-drag-between-sections (TODO-081)
//
// Confirmation dialog shown when a user drops a document onto a
// different section node in the SectionTree. Asks the user to confirm
// moving the document to the target section before firing the PATCH.

import type { CSSProperties, ReactElement } from 'react';

export interface ReclassifyConfirmDialogProps {
  readonly documentName: string;
  /** CTD section code (or label) for the document's current section. */
  readonly fromSection: string;
  /** CTD section code (or label) for the target (drop-target) section. */
  readonly toSection: string;
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}




const docNameStyle: CSSProperties = {
  margin: '0 0 12px 0',
  fontSize: 13,
  fontWeight: 600,
  color: 'var(--text, #111827)',
  fontFamily: 'monospace',
  wordBreak: 'break-all',
};

const arrowStyle: CSSProperties = {
  margin: '0 0 20px 0',
  fontSize: 13,
  color: 'var(--text-muted, #6B7280)',
};

const footerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 8,
};

const cancelBtnStyle: CSSProperties = {
  padding: '7px 16px',
  fontSize: 13,
  fontWeight: 600,
  background: 'var(--surface2, #F9FAFB)',
  border: '1px solid var(--border, #D1D5DB)',
  borderRadius: 6,
  cursor: 'pointer',
  color: 'var(--text, #374151)',
};

const confirmBtnStyle: CSSProperties = {
  padding: '7px 16px',
  fontSize: 13,
  fontWeight: 600,
  background: 'var(--accent, #2563EB)',
  border: 'none',
  borderRadius: 6,
  cursor: 'pointer',
  color: '#fff',
};

export function ReclassifyConfirmDialog({
  documentName,
  fromSection,
  toSection,
  onConfirm,
  onCancel,
}: ReclassifyConfirmDialogProps): ReactElement {
  // phase-movable-dialogs — shared movable shell.
  return (
    <MovableDialog
      persistKey="compiler.reclassifyConfirm"
      title={<span data-testid="reclassify-dialog-title">Move document to {toSection}?</span>}
      ariaLabel="Move document to another section"
      testId="reclassify-confirm-dialog"
      width={440}
      zIndex={1000}
    >
      <>
        <p data-testid="reclassify-dialog-doc-name" style={docNameStyle}>
          {documentName}
        </p>
        <p data-testid="reclassify-dialog-arrow" style={arrowStyle}>
          Current: <strong>{fromSection}</strong> → New: <strong>{toSection}</strong>
        </p>
        <div style={footerStyle}>
          <button
            type="button"
            data-testid="reclassify-cancel-btn"
            style={cancelBtnStyle}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="reclassify-confirm-btn"
            style={confirmBtnStyle}
            onClick={onConfirm}
          >
            Move Document
          </button>
        </div>
      </>
    </MovableDialog>
  );
}
